import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, TrendingUp } from 'lucide-react';
export function WhyItFails() {
  return <section className="py-24 px-6 bg-cream-dark/30" data-id="element-149">
      <div className="max-w-6xl mx-auto" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <span className="text-gold font-semibold tracking-widest text-xs uppercase mb-4 block" data-id="element-152">
            La Autopsia del Silencio
          </span>
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-153">
            Por qué lo que has intentado no funciona
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-154">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-155">
            <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-156">
              La mayoría de los consejos matrimoniales actuales fallan porque
              asumen que ambas personas están dispuestas a trabajar. Pero en una
              crisis real, casi siempre hay una persona{' '}
              <strong className="text-navy font-medium" data-id="element-157">"perseguidora"</strong>{' '}
              y una{' '}
              <strong className="text-navy font-medium" data-id="element-158">"distante"</strong>.
            </p>
            <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-159">
              Si tú eres quien persigue, cada mensaje de texto largo, cada
              "tenemos que hablar" y cada llanto actúa como repelente. Estás
              intentando apagar un fuego emocional con baldes de lógica.
            </p>

            <div className="bg-white p-6 md:p-8 rounded-xl border border-gold/20 shadow-sm mt-8 flex items-start gap-4" data-id="element-160">
              <div className="bg-gold/10 p-3 rounded-full shrink-0" data-id="element-161">
                <TrendingUp className="w-6 h-6 text-gold" data-id="element-162" />
              </div>
              <div data-id="element-163">
                <h4 className="font-serif text-xl mb-2 text-navy" data-id="element-164">
                  La erosión por indiferencia
                </h4>
                <p className="text-charcoal-light text-sm leading-relaxed" data-id="element-165">
                  En 2026, la mayor causa de ruptura no son las peleas
                  explosivas. Google muestra un{' '}
                  <strong className="text-navy" data-id="element-166">aumento del 40%</strong> en
                  búsquedas sobre "compañeros de piso sin sexo".
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-navy text-cream p-8 md:p-12 rounded-2xl relative overflow-hidden shadow-xl" data-id="element-167">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-168"></div>

            <div className="flex items-center gap-3 mb-8" data-id="element-169">
              <AlertCircle className="w-6 h-6 text-gold" data-id="element-170" />
              <h3 className="text-gold font-serif text-2xl" data-id="element-171">El Error #1</h3>
            </div>

            <p className="text-2xl md:text-3xl font-serif leading-snug mb-8" data-id="element-172">
              "Creer que necesitas que tu pareja esté de acuerdo contigo para
              salvar la relación."
            </p>

            <div className="w-12 h-px bg-gold/30 mb-8" data-id="element-173"></div>

            <p className="text-cream/80 leading-relaxed" data-id="element-174">
              No es cierto. Puedes cambiar la dinámica del matrimonio tú solo/a
              si sabes qué palancas presionar. Tu pareja no está huyendo de ti,
              está huyendo de la tensión que siente cuando está contigo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}